/* eslint-disable @next/next/no-img-element */
'use client';
import React from 'react';
import classNames from 'classnames';
import {LocalizedHtml, useI18n} from '@udemy-v2/i18n';

import styles from './default-footer.module.scss';

export const Footer: React.FC = () => {
    const {gettext, locale} = useI18n();
    return (
        <footer className={classNames('ud-color-scheme-dark', styles['footer-container'])}>
            <div className={styles['footer-section']}>
                <div className={`${styles.notice} ud-heading-lg`}>
                    <LocalizedHtml
                        html={gettext(
                            'Top companies choose <a class="link">Udemy Business</a> to build in-demand career skills.',
                        )}
                        interpolate={{
                            link: (
                                <a
                                    className={styles.invertedLink}
                                    href={`/udemy-business/?locale=${locale}&path=request-demo-mx%2F&ref=footer-ad`}
                                    target="_blank"
                                    rel="noopener"
                                />
                            ),
                        }}
                    />
                </div>
                <div className={styles['partner-logos']}>
                    <img
                        className={styles['partner-logo']}
                        src="https://s.udemycdn.com/partner-logos/v4/nasdaq-light.svg"
                        alt="Nasdaq"
                        height="44"
                        width="115"
                        loading="lazy"
                    />
                    <img
                        className={styles['partner-logo']}
                        src="https://s.udemycdn.com/partner-logos/v4/volkswagen-light.svg"
                        alt="Volkswagen"
                        height="44"
                        width="44"
                        loading="lazy"
                    />
                    <img
                        className={styles['partner-logo']}
                        src="https://s.udemycdn.com/partner-logos/v4/box-light.svg"
                        alt="Box"
                        height="44"
                        width="67"
                        loading="lazy"
                    />
                    <img
                        className={styles['partner-logo']}
                        src="https://s.udemycdn.com/partner-logos/v4/netapp-light.svg"
                        alt="NetApp"
                        height="44"
                        width="115"
                        loading="lazy"
                    />
                    <img
                        className={styles['partner-logo']}
                        src="https://s.udemycdn.com/partner-logos/v4/eventbrite-light.svg"
                        alt="Eventbrite"
                        height="44"
                        width="115"
                        loading="lazy"
                    />
                </div>
            </div>
        </footer>
    );
};
